<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Login to access all features</v-card-title>
        <v-layout column justify-center px-4>
        	<v-flex xs12>
            <v-text-field
              name="input-1"
              v-model="email"
              label="Username"
              id="username"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              name="input-2"
              v-model="pass"
              label="Password"
              id="password"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat v-on:click="login">Login</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
	import firebase from 'firebase'

	export default {
		name: "Login",
		data: function(){
			return{
				dialog: true,
				email: '',
				pass: ''
			}
		},
		methods: {
			login: function(){
				firebase.auth().signInWithEmailAndPassword(this.email, this.pass).then((user) =>{
					console.log("connected")
					this.dialog = false

				}, function(err){
					console.log("error");
				} );
			}
		}
	}
</script>

<style scoped>
	
</style>


// WEBPACK FOOTER //
// src/components/Login.vue